import { Vector2 } from '@babylonjs/core';
import { ElementType, SpecyficType } from './element';
import store from '@/store';
import { Product, ProductType } from '@/store/modules/product';
import { chestFurnitureElementsProvider } from './elementProvider/chestFurnitureElements';
import { deskElementsProvider } from './elementProvider/deskElementsProvider';
import { bedsidetableElementsProvider } from './elementProvider/bedsidetableElementsProvider';
import { dressingElementsProvider } from './elementProvider/dressingElementsProvider';

export class ElementMenuItem {
    constructor(
        public avatar: string,
        public text: string,
        public model: string,
        public normal: string,
        public light: string,
        public shape: Vector2,
        public type: ElementType,
        public specyficType: SpecyficType = SpecyficType.OTHER,
        public subElements: ElementMenuItem[] = [],
        public tooltip: string[] = [],
        public useZoom: boolean = false,
    ) { }
}

store.subscribe((mutation) => {
    if (mutation.type === 'setProduct') {
        const product: Product = store.getters.product;
        let newElements: ElementMenuItem[] = [];
        if (product.type === ProductType.CHEST_FURNITURE) {
            newElements = chestFurnitureElementsProvider.get(product);
        }
        if (product.type === ProductType.DESK) {
            newElements = deskElementsProvider.get(product);
        }
        if (product.type === ProductType.DRESSING) {
            newElements = dressingElementsProvider.get(product);
        }
        if (product.type === ProductType.BEDSIDE_TABLE) {
            newElements = bedsidetableElementsProvider.get(product);
        }
        elements.splice(0, elements.length);
        elements.push(...newElements);
    }
});

export const elements: ElementMenuItem[] = [];
